import invariant from 'invariant';
import { DETACHED_INIT, DETACHED_REMOVE } from '../detachedRow/types';
import { DATA_MARK_ERRORS_AS_DIRTY, DATA_REDO, DATA_ROW_REMOVE, DATA_UNDO, DATA_UNDO_ALL, DATA_UPDATE_ROW } from './types';
export const initDetachedRow = (id, row)=>{
    invariant(id, 'id is missing.');
    invariant(row, 'row is missing.');
    return {
        type: DETACHED_INIT,
        detachedId: id,
        row
    };
};
export const removeDetachedRow = (id)=>{
    invariant(id, 'id is missing.');
    return {
        type: DETACHED_REMOVE,
        detachedId: id
    };
};
/**
 * Triggar en `updateIn` för angiven path där callbacken körs. Denna funktion är lämplig att använda då man
 * vill modifiera data i samband med att en registervariabel ändrats, t.ex. i en `onValueChange`-callback.
 *
 * @param path {array}        - Sökvägen från datans rot till var registervariabeln finns.
 * @param callback {function} - Callback-funktion som får immutable-raden som parameter. Efter modifieringar gjorts
 * @param options {object} - Extra-options. Om 'updateHistory' sätts till true läggs nya gamla in i history.
 * ska raden returneras.
 */ export const updateRow = (path, callback, options)=>{
    invariant(Array.isArray(path), 'path must be an array.');
    invariant(typeof callback === 'function', 'callback must be a function.');
    return {
        type: DATA_UPDATE_ROW,
        path: options?.path || path.concat(options?.appendPath || []),
        callback: callback,
        options: options,
        detachedId: options?.detachedId
    };
};
/**
 * Tar bort raden som `path` hänvisar till.
 *
 * @param path {array}       - Sökvägen från datans rot till vilken tabell och rad som ska tas bort.
 * @param options
 */ export const removeRow = (path, options)=>{
    invariant(Array.isArray(path), 'path must be an array.');
    return {
        type: DATA_ROW_REMOVE,
        path: path,
        detachedId: options?.detachedId
    };
};
export const markErrorsAsDirty = (options)=>{
    return {
        type: DATA_MARK_ERRORS_AS_DIRTY,
        detachedId: options?.detachedId,
        validationPredicate: options?.validationPredicate
    };
};
/**
 * Ångrar senaste händelsen.
 */ export const undo = (options)=>{
    return {
        type: DATA_UNDO,
        detachedId: options?.detachedId
    };
};
/**
 * Ångrar alla händelser.
 */ export const undoAll = (options)=>{
    return {
        type: DATA_UNDO_ALL,
        detachedId: options?.detachedId
    };
};
export const redo = (options)=>{
    return {
        type: DATA_REDO,
        detachedId: options?.detachedId
    };
};
